












import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GFormWrapper',
  props: {
    name: { type: String as PropType<string>, required: true },
    action: { type: String as PropType<string>, required: true },
    method: { type: String as PropType<string>, required: true },
  },
});
